import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { path } from 'ramda';
import { getConfig } from '@cian/config/browser';
import { getLogger } from '@cian/logger/browser';
import { TDevice } from '@cian/utils';
import { UiKitContextProvider } from '@cian/ui-kit/context';

import { TReduxStore } from '../../../shared/types/redux';
import { Application } from '../../../shared/containers/App';

interface IDependencies {
  store: TReduxStore;
}

export function renderApplication(dependencies: IDependencies) {
  const config = getConfig();
  const { store } = dependencies;
  const deviceType = path(['page', 'deviceType'], store.getState()) as TDevice;

  const projectName = config.getStrict<string>('projectName');

  const rootElement = document.getElementById(projectName as string);

  if (!rootElement) {
    throw new Error(`Unable to find element #${projectName}`);
  }

  ReactDOM.hydrate(
    <UiKitContextProvider deviceType={deviceType} useStaticDeviceType>
      <Application config={config} logger={getLogger()} reduxStore={store} />
    </UiKitContextProvider>,
    rootElement,
  );
}
